import { abbreviateLargeNumber } from '~/utilities';
import { Content, GrayEye, RedFlame } from './SocialProof.styles';

type OwnProps = {
  count: number;
  isHot: boolean;
};

const Views = ({ count, isHot }: OwnProps) => {
  const copy = count === 1 ? 'View This Week' : 'Views This Week';

  return (
    <Content data-qa="Social-Proof-Views">
      <GrayEye />
      <span className="count flame-on-top">
        {isHot && <RedFlame height="11px" width="11px" />}
        <span>{abbreviateLargeNumber(count)} </span>
      </span>
      <span className="copy">{copy} </span>
    </Content>
  );
};

export default Views;
